import { page404, page500 } from "$src/routes";
import { get } from 'svelte/store';

const cachePrefix = "page:";

function regexMatch(path, uri) {
    const keys = [];

    const tmp = path.match(/\[\w+\]/g);
    if (tmp) {
        tmp.forEach(key => {
            keys.push(key.substring(1, key.length - 1));
            path = path.replace(key, "(\\w+)");
        });
    }

    const reg = new RegExp("^" + path + "$");

    const res = reg.exec(uri)
    if (res) {
        let params = {};
        for (let i = 0; i < keys.length; i++) {
            params[keys[i]] = res[i + 1];
        }

        return params;
    }

    return null;
}

function match(routes, url) {
    const uri = url.pathname

    for (let i = 0; i < routes.length; i++) {
        let path = routes[i].path;

        let params = regexMatch(path, uri);
        if (params) {
            return Object.assign({}, routes[i], { params: Object.assign({}, routes[i].params || {}, params) });
        }
    }

    return null
}

async function loader(doing) {
    return new Promise((resolve, reject) => {
        let timer = setTimeout(() => {
            reject(new Error('timeout'));
        }, import.meta.env.VITE_PAGE_TIMEOUT);

        doing.then((data) => {
            clearTimeout(timer);
            resolve(data);
        }).catch(e => {
            clearTimeout(timer);
            reject(e);
        });
    });
}

async function loadPage(context, routes, url) {
    const res = match(routes, url)

    if (!res) {
        return {
            status: 404,
            render: page404,
            props: { msg: "404 Not Found." }
        }
    }

    const p = await loader(res.load());

    const params = new URLSearchParams();
    url.searchParams.forEach((v, k) => {
        params.append(k, v);
    });

    for (const key in res.params) {
        params.set(key, res.params[key]);
    }

    const api = context.get('api')

    const input = {
        url,
        query: params,
        api,
        context,
    }

    const store = context.get('store');

    const cachekey = cachePrefix + url.pathname + url.search;

    const resp = p.load ? await store.load(cachekey, async () => await p.load(input)) : {};

    if (!import.meta.env.SSR) {
        store.cache.delete(cachekey);
    }

    if (resp.status && resp.status != 200) {
        return {
            status: resp.status,
            render: resp.status == 404 ? page404 : page500,
            props: resp.props || {},
        }
    }

    const redirect = (resp.redirect && resp.redirect[0] == '/') ? import.meta.env.VITE_APP_BASE + resp.redirect.substring(1) : resp.redirect;

    return {
        status: resp.status || 200,
        redirect,
        headers: resp.headers,
        render: p.default,
        props: resp.props,
    }
}

function goto(url) {
    return function (href) {
        let x = new URL(href, get(url));
        if (owns(x)) {
            history.pushState({}, "", x.href)
            url.set(x)
        } else {
            location.href = x.href
        }
    }
}

function gotoSSR() {
    return function () {
        throw new Error("服务器端禁止调用goto()!");
    }
}

function owns(url) {
  let base = import.meta.env.VITE_APP_BASE;
  return url.origin === location.origin && url.pathname.startsWith(base);
}


export { goto, gotoSSR, match, loadPage, regexMatch, owns }
